var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":this.model.name,"width":780,"visible":_vm.visible,"confirmLoading":_vm.loading,"footer":null},on:{"ok":() => { _vm.$emit('ok') },"cancel":() => { _vm.$emit('cancel') }}},[_c('div',{domProps:{"innerHTML":_vm._s(this.model.work_resume)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }